mutation SetMyProfilePicture($s3Key: String!) {
  picture: StreamToolsSetMyProfilePicture(s3Key: $s3Key) {
    pictureUrl
  }
}
